module.exports = __webpack_public_path__ + "6ebbf60cda8f26a64d3d9b53d43c49c1.png";